import { render } from "./RoomRates.vue?vue&type=template&id=73660927"
import script from "./RoomRates.vue?vue&type=script&lang=js"
export * from "./RoomRates.vue?vue&type=script&lang=js"

import "./RoomRates.vue?vue&type=style&index=0&id=73660927&lang=scss"

import exportComponent from "/srv/crewmaldives/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__